import React from 'react'
import Victual from '../../Victual/Victual';

export default () => {
  return (
    <div className='list'>
      <h2 id='bevereges'>Bevereges</h2>
      <Victual name='Beer' desc='Lorum ipsum' price='2.0'/>
      <Victual name='Tea' desc='Lorum ipsum' price='2.5'/>
      <Victual name='Wine' desc='Lorum ipsum' price='12.0'/>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Menu/Categories/Bevereges/Bevereges.js